import {ITableColumn} from '../../types';
import {ReactNode} from 'react';
import {Application} from "../applications/types.ts";
import {Product} from "../products/types.ts";


export enum ApplicationProductStatus {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE'
}

export type ApplicationProductFormType = {
                                             applicationId?: string
                                             productId?: string,
                                         } & { [key: string]: any }


export type ApplicationProduct = {
                                     id: string,
                                     applicationId: string,
                                     application: Application,
                                     productId: string,
                                     product: Product,
                                     applicationProductStatus: ApplicationProductStatus,
                                     position?: number,
                                     createdByUsername?: string,
                                     createdBy?: { givenName: string, familyName: string },
                                     managedByUsername?: string
                                     managedBy?: { givenName: string, familyName: string },
                                     created?: string,
                                     updated?: string,
                                 } & { [key: string]: any }


export type ApplicationProductRecordFormProps = {
    record: ApplicationProduct,
    handleSubmit: (values: ApplicationProduct) => void
    handleCancel: () => void
}

export interface IApplicationProductTableColumn extends ITableColumn {
    render?: (item: ApplicationProduct) => ReactNode;
}
